import { render, staticRenderFns } from "./AfterBossPage.vue?vue&type=template&id=2d6b4b65&"
import script from "./AfterBossPage.vue?vue&type=script&lang=ts&"
export * from "./AfterBossPage.vue?vue&type=script&lang=ts&"
import style0 from "./AfterBossPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports